// extracted by mini-css-extract-plugin
module.exports = {"intro":"Ibeq6","introText":"_1ZN88","cta":"_1lgUP","label":"RrrCN","imgIntro":"w3J80"};